/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FacilityRating } from '../models/FacilityRating';
import type { FacilityRatingUpdate } from '../models/FacilityRatingUpdate';
import type { PaginatedFacilityRatingList } from '../models/PaginatedFacilityRatingList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FacilityRatingsService {

    /**
     * @returns PaginatedFacilityRatingList
     * @throws ApiError
     */
    public static facilityRatingsList({
        facility,
        limit,
        offset,
    }: {
        facility: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedFacilityRatingList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/facility-ratings/',
            query: {
                'facility': facility,
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns FacilityRating
     * @throws ApiError
     */
    public static facilityRatingsCreate({
        requestBody,
    }: {
        requestBody: FacilityRating,
    }): CancelablePromise<FacilityRating> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/facility-ratings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns FacilityRating
     * @throws ApiError
     */
    public static facilityRatingsRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<FacilityRating> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/facility-ratings/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns FacilityRatingUpdate
     * @throws ApiError
     */
    public static facilityRatingsUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: FacilityRatingUpdate,
    }): CancelablePromise<FacilityRatingUpdate> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/facility-ratings/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static facilityRatingsDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/facility-ratings/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
